import builder from '../builder';
import VideoGame360 from '../../streamline-icons/light/video-game-360-vr.svg';

export default builder('IconVideoGame360Light', VideoGame360);
